import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, FormGroup, Button, Form, Input, Label, Alert, Spinner, InputGroup } from "reactstrap";
import config from "../../config";
import house_icon from "../../assets/images/register_bg.png";
import { toast } from "react-toastify";
import { showErrorToast } from "../utils";

const VerificationPage = () => {
    const navigate = useNavigate();
    const [otp, setOtp] = useState("");
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setErrorMsg("");
        const requestUrl = `${config.get("API_URL")}/user/verify-otp`;
        const postData = {
            email,
            otp,
            project_type: "onmls",
        };

        try {
            const response = await fetch(requestUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(postData),
            });

            if (!response.ok) {
                const errorResponse = await response.json(); // Assuming the server sends a JSON response for errors
                return showErrorToast(errorResponse.error || "Verification failed. Please try again.", {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
            }

            const data = await response.json();

            if (data.message) {
                showErrorToast(data.message, { autoClose: 3000, pauseOnHover: false });
                navigate("/login");
            } else {
                throw new Error(data?.detail || "Verification failed: No success message received");
            }
        } catch (error) {
            setErrorMsg(error.message || "Verification failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    // title
    document.title = `Verification Page | ${config.get("COMPANY_NAME")}`;

    return (
        <React.Fragment>
            <div className="auth-main-wrapper">
                <div className="tw-justify-between ">
                    <div className="tw-w-[100%] md:tw-w-[100%] md:tw-z-0 ">
                        <img src={house_icon} className="tw-object-cover tw-h-[450px] md:tw-h-screen tw-w-full" alt="home" />
                    </div>

                    <div
                        className="tw-h-full tw-px-10 tw-rounded-t-[40px] md:tw-rounded-tr-none md:tw-rounded-t-0  md:tw-rounded-l-[40px] tw-flex tw-items-center tw-justify-center tw-absolute tw-top-[400px] md:tw-top-0 tw-right-0 tw-z-10 justify-content-center tw-overflow-y-auto tw-w-full md:tw-w-[65%] tw-text-[#fff] "
                        style={{ background: "rgba(0, 0, 0, 0.68)" }}
                    >
                        <div className="tw-w-[95%] md:tw-w-[60%] ">
                            <div className="tw-w-full my-0 pt-sm-1">
                                <Container>
                                    <Row className="justify-content-center my-0 pt-sm-1 " style={{ marginTop: "-7%" }}>
                                        <Col md={8} lg={6} xl={5} className="tw-w-full">
                                            <div className="text-center mb-1">
                                                <h4
                                                    style={{ marginTop: "-5%" }}
                                                    className="tw-text-[20px] md:tw-text-[36px] tw-text-start md:tw-text-center 2xl:tw-text-[55px]"
                                                >
                                                    Verify Your Account
                                                </h4>
                                                <p className="text-muted mb-4 tw-text-white">Enter the verification code sent to your email.</p>
                                            </div>
                                            <Card className="tw-bg-transparent tw-border-none">
                                                <CardBody>
                                                    {errorMsg && <Alert color="danger">{errorMsg}</Alert>}
                                                    <Form onSubmit={handleSubmit}>
                                                        <FormGroup>
                                                            {/* <Label for="email" className="tw-text-white">
                                                                Email
                                                            </Label> */}
                                                            <InputGroup className="mb-3 bg-soft-light rounded-3">
                                                                {/* <span className="input-group-text text-muted" id="basic-addon3">
                                                                    <i className="ri-user-2-line"></i>
                                                                </span> */}
                                                                <input
                                                                    type="email"
                                                                    name="email"
                                                                    id="email"
                                                                    // className="form-control form-control-lg border-light bg-soft-light"
                                                                    className=" tw-px-3 tw-text-white tw-w-full tw-placeholder-white tw-h-10 tw-outline-none tw-bg-transparent tw-border-b tw-border-white 2xl:tw-text-[18px]"
                                                                    placeholder="Enter your email"
                                                                    value={email}
                                                                    onChange={(e) => setEmail(e.target.value)}
                                                                    required
                                                                />
                                                            </InputGroup>
                                                        </FormGroup>
                                                        <FormGroup>
                                                            {/* <Label for="otp" className="tw-text-white">
                                                                Verification Code
                                                            </Label> */}
                                                            <InputGroup className="mb-3 bg-soft-light rounded-3">
                                                                {/* <span className="input-group-text text-muted">                  
                                                                    <i className="ri-shield-keyhole-line"></i>
                                                                </span> */}
                                                                <input
                                                                    type="text"
                                                                    name="otp"
                                                                    id="otp"
                                                                    placeholder="Enter verification code"
                                                                    className=" tw-px-3 tw-text-white tw-w-full tw-placeholder-white tw-h-10 tw-outline-none tw-bg-transparent tw-border-b tw-border-white 2xl:tw-text-[18px]"
                                                                    // className="form-control form-control-lg border-light bg-soft-light"
                                                                    value={otp}
                                                                    onChange={(e) => setOtp(e.target.value)}
                                                                    required
                                                                />
                                                            </InputGroup>
                                                        </FormGroup>
                                                        <div className="d-grid">
                                                            <Button
                                                                color="new"
                                                                block
                                                                className="waves-effect tw-text-white waves-light custom-sign-in-button"
                                                                type="submit"
                                                                disabled={loading}
                                                            >
                                                                {loading ? <Spinner size="sm" color="light" /> : "Sign In"}
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default VerificationPage;
